import { useContext, useMemo } from 'react';

import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';
import { KETO } from 'lib/constants';

const FirstWeekDisclaimer = ({ box, includesServingRange }) => {
  const { user } = useContext(UserContext);
  const userHasKetoOptIn = useMemo(() => {
    return user?.optIns?.includes(KETO);
  }, [user?.optIns]);

  const mealTypeText = userHasKetoOptIn ? 'Keto-Friendly meals' : 'Meals';

  return (
    <div className="flex flex-col pt-4 text-left">
      <Text htmlElement="span" brandStylesOverrides="textSm text-light">
        {includesServingRange
          ? `${mealTypeText} range between ${box?.pricePerServingLowFormatted} and ${box?.pricePerServingHighFormatted}. Your weekly price will adjust according to your
            recipe selections.`
          : `Your first week total is an estimation based on a per serving price of ${
              box?.promoApplied
                ? box?.promo.pricePerServingFormatted
                : box?.pricePerServingFormatted
            }. Your weekly price will adjust according to your recipe selections.`}
      </Text>
    </div>
  );
};

FirstWeekDisclaimer.propTypes = {
  box: PropTypes.shape({
    promoApplied: PropTypes.bool.isRequired,
    pricePerServingFormatted: PropTypes.string.isRequired,
    pricePerServingLowFormatted: PropTypes.string,
    pricePerServingHighFormatted: PropTypes.string,
    promo: PropTypes.shape({
      pricePerServingFormatted: PropTypes.string,
    }),
  }),
  includesServingRange: PropTypes.bool,
};

export default FirstWeekDisclaimer;
